<template>
    <div id="line">
        <van-cell-group>
            <van-cell title="始发地" :value="startStation" is-link @click="startToggle"/>
            <van-cell title="目的地" :value="endStation" is-link @click="endToggle" />
        </van-cell-group>
        <div class="btn">
            <van-button type="warning" round size="large" @click="searchLine">查询</van-button>
        </div>

        <div class="search-result" v-show="lineList.length > 0">
          <van-panel title="查询结果">

            <ul class="line-list">
              <li class="line-item" v-for="item in lineList" :key="item.id">
                <div class="line-info">
                  <span class="line-photo"></span>
                  <div class="line-detail">
                    <p class="line-name">{{item.organName}}<van-rate v-model="item.rate" :count="5" readonly/></p>
                    <p class="line-price">
                      <span>价格：{{item.price}}/kg</span><span>时效：{{item.time}}/kg</span>
                    </p>
                  </div>
                </div>
                <router-link :to="'/search/companyprofile/'+item.organId" tag="div" class="line-btn">
                  查询详情
                </router-link>
              </li>
            </ul>

          </van-panel>
        </div>

        <!-- 省市区弹出框 -->
        <van-popup v-model="startShow" position="bottom">
            <van-area :area-list="areaList" :value="startAreaId.toString()" @cancel="startToggle" @confirm="confirmStartArea" />
        </van-popup>
        <!-- 省市区弹出框 -->
        <van-popup v-model="endShow" position="bottom">
            <van-area :area-list="areaList" :value="endAreaId.toString()" @cancel="endToggle" @confirm="confirmEndArea" />
        </van-popup>
    </div>
</template>

<script>
import { Toast } from "vant";
import { city } from "../../utils/city.js";
export default {
  name: "LineSearch",
  data() {
    return {
      startShow: false,
      endShow: false,
      startStation: "广东省-广州市-天河区",
      endStation: "广东省-广州市-天河区",
      areaList: [],
      startAreaId: "440106",
      endAreaId: "440106",
      params: {
        beginProvinceId: "440000",
        beginCityId: "440100",
        beginProvinceName: "广东省",
        beginCityName: "广州市",
        endProvinceId: "440000",
        endCityId: "440100",
        endProvinceName: "广东省",
        endCityName: "广州市",
        logisticsCompanyName: ""
      },
      lineList: []
    };
  },
  created() {
    this.areaList = city;
  },
  methods: {
    confirmStartArea(data) {
      this.params.beginProvinceId = data[0].code;
      this.params.beginCityId = data[1].code;
      this.params.beginProvinceName = data[0].name;
      this.params.beginCityName = data[1].name;
      this.startStation =
        data[0].name + "-" + data[1].name + "-" + data[2].name;
      this.startAreaId = data[0].code + "-" + data[1].code + "-" + data[2].code;
      this.startToggle();
    },
    confirmEndArea(data) {
      this.params.endProvinceId = data[0].code;
      this.params.endCityId = data[1].code;
      this.params.endProvinceName = data[0].name;
      this.params.endCityName = data[1].name;
      this.endStation = data[0].name + "-" + data[1].name + "-" + data[2].name;
      this.endAreaId = data[0].code + "-" + data[1].code + "-" + data[2].code;
      this.endToggle();
    },
    startToggle() {
      this.startShow = !this.startShow;
    },
    endToggle() {
      this.endShow = !this.endShow;
    },
    searchLine() {
      this.$axios({
        url: "merchant/list/line",
        method: "post",
        headers: {
          "content-type": "application/json;charset=utf-8"
        },
        data: {
          params: this.params
        }
      }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data;
          data.forEach(val => {
            if (!val.rate) {
              val.rate = 5;
            }
          });
          this.lineList = data;
          if (data.length === 0) {
            Toast({
              message: "无查询结果",
              duration: 2000
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#line {
  .btn {
      padding: 0.25rem;
      text-align: center;
  }
  .line-list {
    padding: 0 0.25rem 0.25rem;
    .line-item {
      border: 1px solid #ddd;
      margin: 0.25rem 0;
      border-radius: 5px;
      .line-info {
        padding: 0.25rem;
        display: flex;
        .line-photo {
          width: 1.25rem;
          height: 1.25rem;
          display: inline-block;
          background-image: url(../../assets/wuliu1.png);
          background-size: 100%;
          background-repeat: no-repeat;
          border: 1px solid #ddd;
          margin-right: 0.25rem;
        }
        .line-detail {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          font-size: 0.375rem;
          .line-name {
            display: flex;
            color: #666;
          }
          .line-price {
            display: flex;
            justify-content: space-between;
          }
        }
      }
      .line-btn {
        border-top: 1px solid #ddd;
        text-align: center;
        padding: 0.25rem 0;
        color: #666;
      }
    }
  }
}
</style>
